export default __webpack_public_path__ + "static/media/backgroundmobile.2f10f96c.png";